import { HourlyForecastProviderV5 } from '../providers/hourlyForecastProviderV5';
import { AsyncAction } from '../../base-classes/asyncAction';
import { mapParamsToObject } from '../../utilities/mapParamsToObject';
import { TimeMS } from '../../utilities';

export const GET_HOURLY_FORECAST_BY_LATLON_V5 = new AsyncAction('GET_HOURLY_FORECAST_BY_LATLON_V5');
export const GET_FULL_HOURLY_FORECAST_V5 = new AsyncAction('GET_FULL_HOURLY_FORECAST_V5');
export const GET_ZERO_HOUR_FORECAST_V5 = new AsyncAction('GET_ZERO_HOUR_FORECAST_V5');

export function getHourlyForecastByLatLon(...params) {
    let paramsObject = {
        location: undefined,
        locationType: undefined,
        offset: undefined,
        length: undefined,
        units: undefined,
        baseUrl: undefined,
        authId: undefined,
        secret: undefined,
        stdParameters: undefined,
        verbose: undefined,
        refresh: undefined,
        tempUnit: undefined,
        pressureUnit: undefined,
        speedUnit: undefined,
        cacheDuration: undefined
    };
    paramsObject = mapParamsToObject(params, paramsObject);

    return {
        type: GET_HOURLY_FORECAST_BY_LATLON_V5.base,
        payload: getHourlyForecast(paramsObject)
    };
}
// This is  used by current conditions action as well.
// Should not be used from outside the common-js library.
export async function getHourlyForecast({
    location,
    locationType,
    offset,
    length,
    units,
    baseUrl,
    authId,
    secret,
    stdParameters,
    verbose,
    refresh,
    tempUnit,
    pressureUnit,
    speedUnit,
    rounding,
    cacheDuration
}) {
    const op = new HourlyForecastProviderV5(baseUrl, authId, secret);
    return await op.getHourlyForecast(
        location,
        locationType,
        offset,
        length,
        units,
        stdParameters,
        verbose,
        refresh,
        tempUnit,
        pressureUnit,
        speedUnit,
        rounding,
        cacheDuration
    );
}

export function getZeroHourForecast(...params) {
    let paramsObject = {
        location: undefined,
        locationType: undefined,
        offset: undefined,
        length: undefined,
        units: undefined,
        baseUrl: undefined,
        authId: undefined,
        secret: undefined,
        stdParameters: undefined,
        verbose: undefined,
        refresh: undefined,
        tempUnit: undefined,
        pressureUnit: undefined,
        speedUnit: undefined,
        cacheDuration: undefined
    };

    paramsObject = mapParamsToObject(params, paramsObject);

    paramsObject.offset = paramsObject.offset || 0;
    paramsObject.length = paramsObject.length || 3;

    return {
        type: GET_ZERO_HOUR_FORECAST_V5.base,
        payload: getHourlyForecast(paramsObject)
    };
}

export const zeroHourRequestParams = {
    offset: 0,
    length: 2,
    cacheDuration: TimeMS.minute * 2.5
};

export const firstSecondHourRequestParams = {
    offset: 1,
    length: 3,
    cacheDuration: TimeMS.minute * 5
};

export const fullHourlyRequestParams = {
    offset: 0,
    length: 144,
    cacheDuration: TimeMS.minute * 15
};

export const defaultRequestParamsList = [
    zeroHourRequestParams,
    firstSecondHourRequestParams,
    fullHourlyRequestParams
];

export function getFullHourlyForecastV5({
        location,
        locationType,
        requestParamsList,
        units,
        baseUrl,
        authId,
        secret,
        stdParameters,
        verbose,
        refresh,
        tempUnit,
        pressureUnit,
        speedUnit,
        rounding
    }) {

    requestParamsList = requestParamsList || defaultRequestParamsList;
    return async (dispatch) => {
        try {
            dispatch({ type: GET_FULL_HOURLY_FORECAST_V5.pending });
            const values = await Promise.all(requestParamsList.map(({ offset, length, cacheDuration }) => {
                return getHourlyForecast({
                    location,
                    locationType,
                    offset,
                    length,
                    units,
                    baseUrl,
                    authId,
                    secret,
                    stdParameters,
                    verbose,
                    refresh,
                    tempUnit,
                    pressureUnit,
                    speedUnit,
                    rounding,
                    cacheDuration
                });
            }));
            dispatch({ type: GET_FULL_HOURLY_FORECAST_V5.fulfilled, payload: values });
        } catch (error) {
            dispatch({ type: GET_FULL_HOURLY_FORECAST_V5.rejected, payload: error});
        }
    };
}
